import React from "react";
import useBackdropClose from "../../hooks/useBackdropClose";
import { useTranslation } from "react-i18next";
import {
  Overlay, Modal, ModalTitle, Body,
  ActionRow, CancelButton, LeaveButton,
} from "./styles";

const LeaveCallModal = ({ onCancel, onConfirm }) => {
  const { t } = useTranslation();

  return (
    <Overlay {...useBackdropClose(onCancel)}>
      <Modal onClick={(e) => e.stopPropagation()}>
        <ModalTitle>{t("call.leaveModal.title")}</ModalTitle>

        <Body>{t("call.leaveModal.body")}</Body>

        <ActionRow>
          <CancelButton type="button" onClick={onCancel}>{t("call.cancel")}</CancelButton>
          <LeaveButton type="button" onClick={onConfirm}>{t("call.leaveModal.confirm")}</LeaveButton>
        </ActionRow>
      </Modal>
    </Overlay>
  );
};

export default LeaveCallModal;
